const ROUTE_PATHS = {
  HOME: "/",
  PROFILE_SETUP: "/profile-setup",
  PROFILE_DETAILS: "/profile-setup/profile-details",
  PROFILE_SETUP_SUCCESS: "/profile-setup-success",
  FBO_HOME: "/abo-home",
  FUEL_ROYALTY_HOME: "/abo-home/fuel-royalty",
  LANDING_FEE_HOME: "/abo-home/landing-fee",
  AIRPORT_BASED_OPERATORS_HOME: "/abo-home/airport-based-operators",

  //Landing Fee
  LANDING_FEE_DATA: "/abo-home/landing-fee/data",
  CREATE_FLIGHT_PLAN: "/abo-home/landing-fee/create-flight-plan",

  //Fuel Royalty
  ADD_FUEL_METER: "/abo-home/fuel-royalty/add-fuel-meter",
  VIEW_SUBMITTED_FUEL_READING: "/abo-home/fuel-royalty/view-submitted-reading",

  //Comman Screens
  INVOICES: "/abo-home/:aboType/invoices",
  VIEW_INVOICES: "/abo-home/:aboType/invoices/:invoiceId",
  ACCOUNT_MAINTENANCE: "/abo-home/account-maintenance",
  NEW_FBO_DATA: "/abo-home/:aboType/new-data",
  VIEW_FBO_DATA: "/abo-home/:aboType/new-data/view",
  VIEW_SUBMITTED_DATA: "/abo-home/:aboType/submitted-data/:submissionId",
  PAYMENT: "/abo-home/:aboType/invoices/payment",
  NOTIFICATIONS: "/abo-home/notifications",
  PAYMENTS: "/abo-home/payments",
};

export default ROUTE_PATHS;
